import { styled } from '@mui/material/styles';

import CustomSlider from '@shared/components/forms/theme-elements/CustomSlider';

const AmbienceVolumeSlider = styled(CustomSlider)(({ theme }) => ({
  '& .MuiSlider-valueLabel': {
    backgroundColor: theme.palette.text.primary,
    borderRadius: '6px',
    color: theme.palette.background.paper,
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 1.2,
    padding: '4px 6px',
    top: '34px',
    left: '50%',
    transform: 'translateX(-50%) scale(0)',
    transformOrigin: 'top center',
  },
  '& .MuiSlider-valueLabel.MuiSlider-valueLabelOpen': {
    transform: 'translateX(-50%) scale(1)',
  },
  '& .MuiSlider-valueLabel::before': {
    display: 'none',
  },
}));

export default AmbienceVolumeSlider;
